export default __webpack_public_path__ + "beta-maps-guides-migrate-custom-render-1200-0063e8db435b3c66c13cc299fb02d5ec.webp";